<template>
    <section class="py-1 rounded-lg sm:space-y-2" key="product-change">
        <header class="flex items-center gap-1">
            <h4 class="text-base text-slate-800 dark:text-slate-100 font-medium leading-6">
                Product changes
            </h4>
            <Tooltip
                text="Let us know if you upgraded or downgraded the card without closing the account."
                placement="right"
                icon="fa-regular fa-circle-info"
            />
        </header>

        <TransitionGroup name="fade">
            <article
                v-if="localCard.product_changed"
                class=""
                key="product-changes-list"
            >
                <ProductChanges
                    v-model:product-changes="productChanges"
                    v-model:welcome-bonus="welcomeBonus"
                    v-model:tiered-bonuses="tieredBonuses"
                    :errors="errors"
                    :connected-account-id="localCard.id"
                    @delete="
                        (connectedAccount) =>
                            $emit('reset-product-changes', connectedAccount)
                    "
                    @deleted="
                        (connectedAccount) =>
                            $emit('product-change-deleted', connectedAccount)
                    "
                    @add="$emit('open-product-change-modal')"
                    @edit="
                        (productChange, index) =>
                            $emit('edit-product-change', productChange, index)
                    "
                    @reset-welcome-bonus="$emit('reset-welcome-bonus')"
                />
            </article>

            <button
                v-if="!localCard.product_changed"
                type="button"
                class="btn-base btn-transparent !pl-0 flex items-center"
                @click="$emit('open-product-change-modal')"
                key="add-product-change-btn"
            >
                <Icon icon="plus" class="mr-1" />
                Add product change
            </button>
        </TransitionGroup>
    </section>
</template>

<script setup>
import Icon from '@/components/ui/icon/icon.vue';
import Tooltip from '@/components/tooltip.vue';
import ProductChanges from '@/components/wallet/partials/product-changes.vue';

defineProps({
    localCard: Object,
    errors: Object,
});

const productChanges = defineModel('productChanges', { type: Array });
const welcomeBonus = defineModel('welcomeBonus', { type: Object });
const tieredBonuses = defineModel('tieredBonuses', { type: Array });

defineEmits([
    'reset-product-changes',
    'product-change-deleted',
    'open-product-change-modal',
    'edit-product-change',
    'reset-welcome-bonus',
]);
</script>
